import React from 'react';
import { RicosContentQueryService } from './ContentQueryService.js';
import 'ricos-content/libs/extract';
import 'ricos-converters';

const contentQueryService = new RicosContentQueryService();
const ContentQueryContext = React.createContext(contentQueryService);

export { ContentQueryContext };
//# sourceMappingURL=ContentQueryContext.js.map
